import React, { useCallback, VFC } from 'react';
import { Button, makeStyles, Theme } from '@dxb-web-ui-framework/design-system';
import { Visibility as VisibilityIcon } from '@dxb-web-ui-framework/design-system/dist/icons';

const useStyles = makeStyles<Theme, { identifier: string | number }>(theme => ({
  root: {
    '& span > svg': {
      color: ({ identifier }) => (!Boolean(identifier) ? '#AAA' : 'secondary'),
    },
  },
}));

export interface ViewDetailsButtonProps {
  identifier: string | number;
  fullWidth?: boolean;
  callback?: Function;
  title?: string;
  ariaLabel?: string;
}

const ViewDetailsButton: VFC<ViewDetailsButtonProps> = ({ identifier, callback, fullWidth, title, ariaLabel }) => {
  const onClick = useCallback(() => {
    if (callback) {
      callback(identifier);
    }
  }, [identifier, callback]);

  const classes = useStyles({ identifier });
  const calculatedFullWidth = typeof fullWidth === 'undefined' ? true : fullWidth;

  return (
    <Button
      fullWidth={calculatedFullWidth}
      title={title}
      aria-label={ariaLabel}
      variant='text'
      size='small'
      color={'secondary'}
      disabled={!Boolean(identifier)}
      isIconButton={true}
      onClick={onClick}
      classes={{ root: classes.root }}>
      <VisibilityIcon color='secondary' />
    </Button>
  );
};

export { ViewDetailsButton };
